import React from "react";
import { Image } from "@singlestore/fusion/components/image";
import { Theme } from "@singlestore/fusion/src/theme-context";
import { cx } from "class-variance-authority";

import "./SingleStoreLogo.scss";

const SINGLESTORE_LOGO_LIGHT =
    "https://images.contentstack.io/v3/assets/bltac01ee6daa3a1e14/bltf8a2a4aa80a78f03/singlestore_logo_docs_black.svg";
const SINGLESTORE_LOGO_DARK =
    "https://images.contentstack.io/v3/assets/bltac01ee6daa3a1e14/blt9a7dde00f24aa4b3/singlestore_logo_docs_white.svg";

type ThemedImage = {
    theme: Theme;
    src: string;
};

const IMAGES: Array<ThemedImage> = [
    { theme: "light", src: SINGLESTORE_LOGO_LIGHT },
    { theme: "dark", src: SINGLESTORE_LOGO_DARK },
];

export type SingleStoreLogoProps = {
    className?: string;
};

export function SingleStoreLogo({ className }: SingleStoreLogoProps) {
    return (
        <>
            {IMAGES.map(({ theme, src }) => {
                const classes = cx("singlestore-logo", className, theme);

                return (
                    <Image
                        key={src}
                        className={classes}
                        src={src}
                        alt="SingleStore Logo"
                        width="197"
                        height="69"
                    />
                );
            })}
        </>
    );
}

SingleStoreLogo.displayName = "SingleStoreLogo";
